"use client";

import { useContent } from "../../content/current";
import LegalContent from "./LegalContent";

export default function PrivacidadContent() {
  const content = useContent();
  return <LegalContent html={content.legalPages.privacidad.html} />;
}
